import { useState, useEffect } from 'react'
import {
  ChakraProvider,
  theme,
} from '@chakra-ui/react';

import Header from './components/header'
import Main from './components/main'
import { useWeb3React } from "@web3-react/core"
function App() {
  const {active} = useWeb3React()
  let [isActive, setIsActive ] = useState(false)
  let [adminOpen, setAdminOpen] = useState(false)
  let [isAdmin, setIsAdmin] = useState(false)
  let [showMyYieldTokens, setShowMyYieldTokens] = useState(false)


  return (
    <ChakraProvider theme={theme}>
      <Header onChange={()=>setIsActive(active)} setAdminOpen={()=>{setAdminOpen(!adminOpen);setShowMyYieldTokens(false)}} isAdmin={isAdmin}  adminOpen={adminOpen} showYieldTokens={show=>{setAdminOpen(false);setShowMyYieldTokens(show)}} yieldTokensShow={showMyYieldTokens}/>
      <Main active={isActive} adminOpen={adminOpen} setIsAdmin={(isAdmin)=>setIsAdmin(isAdmin)} showYieldTokens={showMyYieldTokens}/>
    </ChakraProvider>
  );
}

export default App;
